<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you ever experienced a “mini-stroke” or stroke? <br/>
      <i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.strokes">
      <b-form-checkbox v-model="survey.arteryBlockages.strokes.hadNoStroke"
                       @change="onNoStrokeSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.strokes.hadTIA"
                       @change="onTiaSelected">
        “Mini stroke” (TIA – transient ischemic attack)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.strokes.hadCVA"
                       @change="onCvaSelected">
        Stroke (CVA – cerebral vascular accident)
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      strokes: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoStroke || value.hadTIA || value.hadCVA)
      }
    },

    computed: {
      ...mapState(["survey"]),

      strokes() { return this.survey.arteryBlockages.strokes; }
    },

    methods: {
      onNoStrokeSelected(value) {
        this.setOptions(value, false, false);
      },

      onTiaSelected(value) {
        this.setOptions(false, value, this.strokes.hadCVA);
      },

      onCvaSelected(value) {
        this.setOptions(false, this.strokes.hadTIA, value);
      },

      setOptions(hadNoStroke, hadTIA, hadCVA) {
        this.survey.arteryBlockages.strokes.hadNoStroke = hadNoStroke;
        this.survey.arteryBlockages.strokes.hadTIA = hadTIA;
        this.survey.arteryBlockages.strokes.hadCVA = hadCVA;
      }
    }
  };
</script>